<div class="input-container">
    <input
        type="search"
        (disabled)="true"
        (input)="onSearchTermChange($any($event.target).value)"
        placeholder="Digite nome ou RESID"
        (focus)="onInputFocus()"
        (blur)="onBlur()"
        [(ngModel)]="searchInputText"
        name="search">
    <mat-spinner class="spinner" *ngIf="searchingPatient" diameter="20"></mat-spinner>
    <app-patient-search-drop-down
        *ngIf="(!loadingPatient && searchInputText.length > 2) || (patientsResult().length && !backgroundOn)"
        [patients]='patientsResult()'
        (patientSelected)='selecPatient($event)'>
    </app-patient-search-drop-down>
    <div (click)="resetSearch()" class="background" *ngIf="backgroundOn"></div>
</div>
